const removeEvent = (e) => {
    e.preventDefault()
    e.stopPropagation()
  }
  
  export function disableScroll() {
    document.body.addEventListener('touchmove', removeEvent, { passive: false })
    document.body.addEventListener('onclick', removeEvent, { passive: false })
    document.body.addEventListener('mousewheel', removeEvent, {
      passive: false,
    })
  }
  
  export function enableScroll() {
    document.body.removeEventListener('touchmove', removeEvent)
    document.body.removeEventListener('onclick', removeEvent)
    document.body.removeEventListener('mousewheel', removeEvent)
  }
  
  export function flickingLayout(el, autoScroll) {
    let target = el.labels && el.labels.length != 0 ? el.labels[0] : el
    if (autoScroll) {
      window.scrollBy({
        top: target.getBoundingClientRect().top - 100,
        behavior: 'smooth',
      })
    }
    target.style.zIndex = 1
  
    _.each(window.document.getElementsByClassName('focus_reminder'), (v) =>
      v.classList.remove('focus_reminder')
    )
  
    // void target.offsetWidth
    target.classList.add('focus_reminder')
    try {
      window.navigator.vibrate([200, 200])
    } catch (ignore) {}
  
    // target.style.cursor = 'pointer'
  
    target.addEventListener('click', function() {
      if (target.classList.contains('focus_reminder')) {
        target.style.zIndex = 0
        target.classList.remove('focus_reminder')
      }
    })
  }
  